import { useErrorHandler } from 'components/ErrorHandler/ErrorHandlerContext';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getVersionNumber } from 'utils/api';

const StyledInfo = styled.div`
  color: #231f20;
`;

export const VersionInfo = () => {
  const [t] = useTranslation();
  const [state, setState] = useState();
  const { addError } = useErrorHandler();

  useEffect(() => {
    let ignore = false;

    const fetchVersion = async () => {
      try {
        const result = await getVersionNumber();
        if (!ignore) {
          setState(result.version);
        }
      } catch (error) {
        addError(error);
      }
    };

    fetchVersion();

    return () => (ignore = true);
  }, [addError]);

  return (
    <div>
      <StyledInfo as="div" data-testid="versionNumberDisplay">
        {t('general:applicationName') + ' version ' + state}
      </StyledInfo>
    </div>
  );
};
